// extracted by mini-css-extract-plugin
module.exports = {"header":"header-page_header__UZY2N","headerWrapper":"header-page_headerWrapper__VjDQf"};